// @flow
import React from 'react';
import theme from './RiderPersonaSkills.scss';
import type { List } from 'immutable';
import type { Skill } from 'common/models/flow/Skill';

type Props = {
    data: List<Skill>,
    t: (string, ?Object) => string
};
const RiderPersonaSkills = ({ data, t }: Props) => (
    <div className={theme.riderPersonaSkills}>
        <div className={theme.label}>
            {t('masterRiderPersonaProperties.skills')}
        </div>
        <div className={theme.skillsWrapper}>
            {data.map(skill => (
                <div className={theme.skill} key={skill.id}>
                    {skill.id}
                </div>
            ))}
        </div>
    </div>
);

export default RiderPersonaSkills;
